// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import TabNavigation from '../../../shared/components/tab-navigation';
import {getNavigationTabs} from '../../shared/services/claim-navigation-helper';

const DealerInvoiceHeader = props => {

    const countObject = {
        allClaims: props.allClaimsCount,
        claimSearch: props.claimSearchCount,
        dealerInvoices: props.dealerInvoiceCount
    };

    return (
        <header className='dealer-invoice-header'>
            <TabNavigation tabs={getNavigationTabs(countObject, props.hasSearchResults, true)}/>
        </header>
    );

};

DealerInvoiceHeader.displayName = 'DealerInvoiceHeader';
DealerInvoiceHeader.propTypes = {
    allClaimsCount: PropTypes.number.isRequired,
    claimSearchCount: PropTypes.number.isRequired,
    dealerInvoiceCount: PropTypes.number.isRequired,
    hasSearchResults: PropTypes.bool.isRequired
};

export default DealerInvoiceHeader;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/dealer-invoice-header.js